<template>
  <div>
    <div class="relative h-screen bg-container w-100%">
      <div class="absolute inset-0 bg-black opacity-70"></div>
      <div
        class="h-full grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 top-0 absolute"
      >
        <div
          :class="[
            'loginContainer',
            isMobile ? 'mobile-style' : 'desktop-style',
          ]"
        >
          <div class="z-10 pt-[50px] w-full">
            <!-- login component -->
            <div>
              <div>
                <div class="vflex justify-center">
                  <div>
                    <div
                      style="text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);"
                      :class="styleText"
                      class="text-white text-center h-[64px] pt-[15px] text-[32px]"
                    >
                      BUYERS PORTAL
                    </div>
                    <div
                      style="text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);"
                      :class="styleText"
                      class="mb-4 flex justify-center text-[#ED7D31] w-[520px] text-center justify-center items-center pb-[0px] text-[11px]"
                    >
                      BY MOLDEX REALTY, INC.
                    </div>
                  </div>
                </div>

                <div v-if="BISSelectionComponent" class="w-[520px] px-[75px]">
                  <div class="text-center opacity1">
                    <BISSelection />
                  </div>
                </div>
                <div>
                  <div>
                    <div class="text-center bg-white" v-if="!hide">
                      <!-- if login -->
                      <div v-if="!isSignup && logInShow" class="pt-4">
                        <v-progress-linear
                          v-if="progressbar"
                          :indeterminate="true"
                          color="primary"
                        />
                        <div>
                          <div class="px-[20px]">
                            <div class="my-2">
                              <input
                                class="bg-white border-solid border-2 rounded-md border-black w-full px-4 py-2 outline-none"
                                type="email"
                                v-model="email"
                                placeholder="Email"
                              />
                            </div>
                            <div
                              class="my-2 flex w-full justify-start items-center"
                            >
                              <div
                                class="w-full border-solid border-2 rounded-md border-black flex justify-between items-center"
                              >
                                <input
                                  class="bg-white w-full rounded-md px-4 py-2 outline-none"
                                  :type="pwVisible ? 'password' : 'text'"
                                  v-model="password"
                                  placeholder="Password"
                                />
                                <v-btn @click="openPwVisibility" text>
                                  <v-icon v-if="pwVisible">mdi-eye-off</v-icon>
                                  <v-icon v-else>mdi-eye</v-icon>
                                </v-btn>
                              </div>
                            </div>
                          </div>
                          <div class="flex justify-center my-4">
                            <div class="text-center w-full space-y-1">
                              <div>
                                <v-btn
                                  @click="login"
                                  dark
                                  :loading="loadingLogin"
                                  color="#ED7D31"
                                  class="w-[150px] ont-noto-sans"
                                >
                                  <div
                                    class="text-md items-center flex justify-center"
                                  >
                                    Log in
                                  </div>
                                </v-btn>
                              </div>
                              <v-btn
                                dark
                                :loading="loadingSignup"
                                color="#ED7D31"
                                class="w-[150px] ont-noto-sans"
                                @click="signup"
                              >
                                <div
                                  class="text-md items-center flex justify-center"
                                >
                                  Sign Up
                                </div>
                              </v-btn>
                              <div class="text-white w-full font5 mb-4 mt-1">
                                <div class="text-black text-lg">
                                  {{ subtitle2 }}
                                </div>
                                <div class="text-black text-lg mt-[-10px]">
                                  Sign up here.
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="w-full">
                          <div class="flex h-[20px] items-center pb-4">
                            <div
                              @click="rfp"
                              class="capitalize font6 text-black w-1/2 text-left pl-[20px]"
                            >
                              Request for Password
                            </div>
                            <div
                              class="text-xs capitalize text-black w-1/2 text-right pr-[20px] font6"
                            >
                              Privacy Policy
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- if signup -->
                      <div v-else-if="isSignup" class="bg-white mx-5">
                        <v-progress-linear
                          v-if="progressbar"
                          :indeterminate="true"
                          color="red"
                          height="10px"
                        />
                        <ContractNumber
                          @cancelContractNumber="cancelSignup"
                          @submitContractNumber="enterContractNumber"
                        />
                      </div>
                      <div v-if="otp" class="text-center">
                        <Otp
                          @enterOTP="enterOTP"
                          :emailFound="emailFound"
                          @openBISSelection="openBISSelection"
                        />
                      </div>
                      <div v-if="signupPw" class="text-center my-2">
                        <PassWord @newPwSubmitted="newPwSubmitted" />
                      </div>
                    </div>
                    <div class="items-center flex justify-center">
                      <span
                        ><img :src="img" alt="" class="mt-[50px] w-[120px]"
                      /></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-1/3"></div>
        <div class="w-1/3"></div>
      </div>
    </div>
    <v-dialog
      v-model="rfp_dialog"
      persistent
      :overlay="false"
      :max-width="maxWidth"
      transition="dialog-transition"
    >
      <div class="bg-white p-2">
        <PasswordRequest />
      </div>
    </v-dialog>
    <v-dialog
      v-model="dialogNoEmail"
      persistent
      :overlay="false"
      :max-width="maxWidth"
      transition="dialog-transition"
    >
      <div
        class="bg-black text-white text-center border-yellow-400 border-2 p-2"
      >
        <div>
          <div class="flex justify-end">
            <v-icon color="white" @click="cancelSignup">mdi-close</v-icon>
          </div>
        </div>
        <div class="text-center">Oops!</div>
        <div class="py-4 sm:text-md text-xs">
          Invalid entry. The contract number or company code encoded does not
          match our records. Please contact us at <br />
          buyersportal-helpdesk@moldex.com.ph <br />
          for assistance.
        </div>
        <div class="py-2 text-center">
          <v-btn @click="dialogNoEmail = false">Ok</v-btn>
        </div>
      </div>
    </v-dialog>

    <Dialog
      :show="dialog.show"
      :message="dialog.message"
      @close="dialog.show = false"
    />
  </div>
</template>

<script>
/* eslint-disable */
import PasswordRequest from "./components/PasswordRequest.vue";
import EventBus from "@/EventBus";
import ContractNumber from "./SignUpScreen/components/ContractNumber.vue";
import Otp from "./components/Otp.vue";
import PassWord from "./SignUpScreen/components/PassWord.vue";
import BISSelection from "@/screens/authScreen/SignUpScreen/components/BISSelection.vue";
import axios from "axios";
import Dialog from "@/components/Dialog.vue";
import SecureStorage from "@/utils/secureStorage";

export default {
  data() {
    return {
      isMobile: false,
      dialog: {
        show: false,
        message: "",
      },
      styleText: "font-bold leading-loose tracking-wide font-noto-sans", // Ensure this is included
      progressbar: false,
      loadingLogin: false,
      loadingSignup: false,
      indeterminate: false,
      pwVisible: true,
      buyerName: null,
      customerCode: null,
      emailFound: "",
      BISSelectionComponent: false,
      hide: false,
      dialogNoEmail: false,
      signupPw: false,
      logInShow: true,
      otp: false,
      contractNumber: null,
      contractNumberPrefix: null,
      isSignup: false,
      rfp_dialog: false,
      email: "",
      password: "",
      subtitle1: "Already have an account? Login here.",
      subtitle2: "Don't have an account yet?",
      subtitlePW:
        "Minimum of 8 characters, at least one capital letter, one small letter, and one number.",
      messageNoEmail: "",
      img: require("@/assets/images/moldex_logo.png"),
    };
  },
  mounted() {
    this.checkIfMobile();
    window.addEventListener("resize", this.checkIfMobile);
    EventBus.$on("closeSignup", () => {
      this.closeSignup();
    });
    EventBus.$on("Close_RFP_DIALOG", () => {
      this.rfp_dialog = false;
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.checkIfMobile);
    EventBus.$off("closeSignup");
    EventBus.$off("Close_RFP_DIALOG");
  },
  computed: {
    maxWidth() {
      return this.$vuetify.breakpoint.smAndDown ? "90%" : "300px";
    },
  },
  methods: {
    checkIfMobile() {
      this.isMobile = window.innerWidth <= 768; // Adjust the breakpoint as needed
    },
    showDialog(message) {
      this.dialog.message = message;
      this.dialog.show = true;
    },
    openPwVisibility() {
      this.pwVisible = !this.pwVisible;
    },
    openBISSelection() {
      this.otp = false;
      this.hide = true;
      this.BISSelectionComponent = true;
    },
    close_dialog_rfp() {
      this.rfp_dialog = false;
    },
    rfp() {
      this.rfp_dialog = true;
    },
    onProgressBar(show) {
      this.progressbar = show;
    },
    async login() {
      this.onProgressBar(true);
      this.loadingLogin = true;
      if (!this.password || !this.email) {
        this.showDialog("Please complete the text fields.");
        this.onProgressBar(false);
        this.loadingLogin = false;
        return;
      }

      try {
        const res = await axios.post("/login/login-client", {
          email: this.email,
          password: this.password.trim(),
        });

        if (res.data.status) {
          const authData = {
            authorized: true,
            role: "client",
            token: res.data.token,
            customerCode: res.data.output.user_customer_code,
            email: res.data.output.email_address,
            userId: res.data.output.user_id,
            buyerName: res.data.output.user_buyer_name,
          };

          SecureStorage.setAuthData(authData, false);
          const stored = SecureStorage.getItem("auth");

          if (stored && stored.authorized && stored.customerCode) {
            this.$router.replace({
              name: "Property Selection",
              query: {
                cc: stored.customerCode,
              },
            });
          } else {
            this.showDialog("Unable to save login session. Please try again.");
          }
        } else {
          this.showDialog(res.data.message);
        }
      } catch (error) {
        this.showDialog(
          "Unable to connect to the server. Please check your internet connection and try again."
        );
      } finally {
        this.onProgressBar(false);
        this.loadingLogin = false;
      }
    },

    closeSignup() {
      this.dialog = false;
    },
    signup() {
      this.isSignup = true;
      this.logInShow = false;
    },
    async enterOTP(otp) {
      if (!otp) {
        this.showDialog("Please enter OTP");
      } else {
        let data = {
          otp: otp,
          contract_number: this.contractNumber.contractNumber,
          email: this.emailFound,
        };
        try {
          const res = await axios.post("/otp/validate", data);
          if (res.data.status) {
            this.otp = false;
            this.logInShow = false;
            this.isSignup = false;
            this.signupPw = true;
          } else {
            this.showDialog(res.data.message);
            this.closeSignup();
          }
        } catch (error) {
          this.showDialog(
            "Unable to connect to the server. Please check your internet connection and try again."
          );
        }
      }
    },
    async newPwSubmitted(password) {
      this.onProgressBar(true);
      let data = {
        email: this.emailFound,
        password: password,
        customerCode: this.customerCode,
        buyerName: this.buyerName,
        userGroup: "client",
      };
      try {
        const res = await axios.post("/password/signup", data);
        if (res.data.status) {
          this.onProgressBar(false);
          this.showDialog(res.data.message);
          this.otp = false;
          this.logInShow = true;
          this.isSignup = false;
          this.signupPw = false;
        } else {
          this.onProgressBar(false);
          this.showDialog(res.data.message);
        }
      } catch (error) {
        this.onProgressBar(false);
        this.showDialog(
          "Unable to connect to the server. Please check your internet connection and try again."
        );
      } finally {
        this.isSignup = false;
        this.logInShow = true;
        this.otp = false;
        this.signupPw = false;
      }
    },
    cancelSignup() {
      this.isSignup = false;
      this.logInShow = true;
      this.dialogNoEmail = false;
    },
    async enterContractNumber(contractNumber) {
      if ("contractNumber" in contractNumber) {
        if (contractNumber.contractNumber) {
          if (contractNumber.co_code) {
            let data = {
              contract_number: contractNumber,
            };
            this.onProgressBar(true);
            try {
              const res = await axios.post("/otp/for_signup", data);
              if (res.data.status) {
                this.onProgressBar(false);
                this.showDialog(res.data.message);
                this.otp = true;
                this.contractNumber = contractNumber;
                this.emailFound = res.data.emailFound;
                this.logInShow = false;
                this.isSignup = false;
                this.customerCode = res.data.customerCode;
                this.buyerName = res.data.buyerName;
              } else {
                if (!res.data.exist) {
                  this.dialogNoEmail = true;
                  this.messageNoEmail = res.data.message;
                  this.onProgressBar(false);
                } else {
                  this.onProgressBar(false);
                  this.showDialog(res.data.message);
                }
              }
            } catch (error) {
              this.onProgressBar(false);
              this.showDialog(
                "Unable to connect to the server. Please check your internet connection and try again."
              );
            }
          } else {
            this.showDialog("Please fill in the company code");
            this.onProgressBar(true);
          }
        } else {
          this.showDialog("Please fill in the contract number");
          this.onProgressBar(false);
        }
      } else {
        this.onProgressBar(false);
      }
    },
    noEmail() {
      this.dialogNoEmail = true;
    },
  },
  components: {
    BISSelection,
    PasswordRequest,
    ContractNumber,
    PassWord,
    Otp,
    Dialog,
  },
};
</script>

<style scoped>
.font1 {
  font-family: "Source Sans Pro";
  font-size: 16px;
  font-weight: "bolder";
}

.fontBtn {
  font-family: "Source Sans Pro";
  font-size: 12px;
  font-weight: "bolder";
  box-shadow: 0 1px 2px #fff, /*bottom external highlight*/ 0 -1px 1px #666,
    /*top external shadow*/ inset 0 -1px 1px rgba(0, 0, 0, 0.5),
    /*bottom internal shadow*/ inset 0 1px 1px rgba(255, 255, 255, 0.8); /*top internal highlight*/
  border-radius: 4px;
}

.fontBtn2 {
  font-family: "Source Sans Pro";
  font-size: 12px;
  font-weight: "bolder";
  border-radius: 4px;
}

.font2 {
  color: #000093;
  font-family: "Arial";
  font-size: 27px;
  text-decoration-thickness: 2px;
}

.font3 {
  font-family: "Ballet", cursive;
}

.font5 {
  font-family: "Source Sans Pro";
  font-size: 10px;
}

.font6 {
  font-family: "Source Sans Pro";
  font-size: 16px;
}

.opacity1 {
  background-color: rgba(0, 0, 0, 0.7);
}

/* Apply these styles */
.h-screen {
  height: 100vh;
}

.w-full {
  width: 100%;
}

.object-cover {
  object-fit: cover;
  object-position: center;
}

.bg-container {
  background-image: url("../../assets/images/bg_login.jpg"); /* Replace with the correct path */
  background-size: cover;
  background-position: top;
  background-repeat: repeat;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px; /* Adjust padding as needed */
}

.mobile-style {
  margin: 10px auto;
  width: calc(60% - 50px); /* Ensure the container takes up almost full width */
  padding: 20px 0px; /* Add padding inside the container */
}

.desktop-style {
  margin: 0px auto;
  width: 520px; /* Adjust as needed */
  padding: 20px;
}

@media (max-width: 767px) {
  .bg-container {
    background-position: center;
    background-size: cover;
  }
}
</style>
